import React from 'react'
import ReadMoreLess from './readMoreLess'
export interface NewsFeed {
    title: string,
    description: string,
    isActive?: boolean,
}
export interface NewsFeedProps {
    data: NewsFeed[]
}
const NewsFeed: React.FC<NewsFeedProps> = ({ data }) => {

    return (
        <>
        {data.map((item, id)=>(
            <div key={id} className='flex flex-col gap-5 border-b-[1px] border-[#DBDBDB]'>
            <p className='text-[16px] font-MetropolisMedium leading-6 mt-5'>
               {item.title}
            </p>
            <p className="text-[14px] font-MetropolisBook leading-5 pb-5">
            {item.description.length > 200 ? (
              <ReadMoreLess text={item.description} maxLength={200} />
            ) : (
              item.description
            )}
          </p>
        </div>
        ))} 
        </>
    )
}

export default NewsFeed